import styled from 'styled-components';
import React from 'react';
import { theme } from '../../themes/theme';
import { CircularProgress } from '@mui/material';

const StyledSpinner = styled.div`
    
`;

export const Spinner: React.FC<{
    color?: string;
}> = (props) => {
    return (
        <StyledSpinner color={props.color}>
            <CircularProgress />
        </StyledSpinner>
    );
};
